export default {
    data(){
        return {
            passwordCounterHandler: null,
        }
    },
    methods: {
        passwordCounter: function () {

            let $passwordElement = $('#onetimepasswordRow');
            if (!$passwordElement.length || !$passwordElement.is(":visible")) {
                return;
            }

            var setTime = 300; //5 mins
            if($('[data-expire-in]').length){
                setTime = $('[data-expire-in]').data('expire-in') * 60;
            }

            let endTime = new Date().getTime() + setTime * 1000;
            var timeToCountdown = setTime || 300,
                $minutes = $('.mins'),
                $seconds = $('.secs'),
                minutes = ~~(timeToCountdown / 60),
                seconds = timeToCountdown % 60;

            $minutes.text(minutes);
            $seconds.text('00');

            this.passwordCounterHandler = setInterval(function () {
                let curTime = new Date().getTime();
                timeToCountdown = Math.floor((endTime - curTime) / 1000) ;
                if (timeToCountdown < 0) {
                    $minutes.text(0);
                    $seconds.text('00');
                    var $resendElement = $('.resendOTP');
                    let $confirmBtn = $('.submitOTPBtn')
                    if ($resendElement.length > 0) {
                        $passwordElement.addClass('displayNone');
                        $resendElement.removeClass('displayNone');
                        $confirmBtn.addClass('displayNone');

                    } else {
                        this.notifyError('Error', 'password is expired');
                    }
                    clearInterval(this.passwordCounterHandler);
                }
                else {
                    minutes = ~~(timeToCountdown / 60);
                    seconds = timeToCountdown % 60;
                    if (seconds < 10) {
                        seconds = '0' + seconds;
                    }

                    $minutes.text(minutes);
                    $seconds.text(seconds);
                    // timeToCountdown--;
                }

                //show a reset option after 2 minute so user can request a new otp. This needs throttling
                if ((setTime - timeToCountdown) === 180) {
                    $('#resend-otp-click-here').removeClass('displayNone')
                }

            }.bind(this), 1000);
        },
        // _resendOTP: function () {
        //     let vm = this, $resendOTP = $('.resendOTP'), $otpTime = $('.otpTime '), $confirmBtn = $('.submitOTPBtn');
        //     // TODO Ajax call
        //     $resendOTP.html('<i class="fa fa-spinner fa-spin"></i>');
        //     $resendOTP.prop('disabled', 'disabled');
        //
        //     vm.getAxiosInstance().post('login/sendloginotp', this.new_user).then(response => {
        //         if (response.data.result === 'SUCCESS') {
        //             vm.notifySuccess(this.lang('onetime_password_sent_successfully'))
        //             //reset counter, toast success message,
        //             $resendOTP.addClass('displayNone');
        //             $confirmBtn.removeClass('displayNone');
        //             $resendOTP.html(LANGUAGE['resend']);
        //             vm._passwordCounter();
        //         }
        //     })
        // },
    }
}